import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDownloadErrorStyle0 = cosmosIconCss;

const CosmosIconDownloadError$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDownloadError extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5a7b82f468f144064a28b53ac4eb971edd24f638', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '32e2622f93bd374bccb52ed99869a91e26448e63', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'de43294f01fec9c0d4a661116220aee000afe2e3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.016 2.516a.5.5 0 0 1 .5-.516h.968a.5.5 0 0 1 .5.516l-.219 7a.5.5 0 0 1-.5.484h-.53a.5.5 0 0 1-.5-.484l-.219-7ZM18.5 19h-15a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 .5.5v4h13v-4a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5Zm-8-7.156a.5.5 0 0 0-.5.5v1.25a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1.25a.5.5 0 0 0-.5-.5h-1Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconDownloadErrorStyle0; }
}, [1, "cosmos-icon-download-error", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-download-error"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-download-error":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDownloadError$1);
            }
            break;
    } });
}

const CosmosIconDownloadError = CosmosIconDownloadError$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDownloadError, defineCustomElement };
